import PropTypes from "prop-types";

// Layouts
import MatchesItem from "@Layouts/components/SideBars/SideSelectorMenu/MatchesItem";

// Customs
import DefaultInformation from "@PayPlans/Layouts/SideSelector";

export default function SideInformation(props) {
	const { title = "", matches = { fullMatchList: [], partialMatchList: [] }, isLoadingComponent = false, selected = false } = props;

	return (
		<MatchesItem
			{...props}
			title={title}
			matches={matches}
			isSelected={selected}
			loading={isLoadingComponent}
			additional={<DefaultInformation {...props} />}
		/>
	);
}
SideInformation.propTypes = {
	title: PropTypes.string,
	position: PropTypes.string,
	defaultSelectedId: PropTypes.string,
	compareLabel: PropTypes.string,
	isLoadingComponent: PropTypes.bool,
	selected: PropTypes.bool,
	matches: PropTypes.shape({
		fullMatchList: PropTypes.arrayOf(PropTypes.string),
		partialMatchList: PropTypes.arrayOf(PropTypes.string),
	}),
};
